import moment from "moment";
import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { CiWallet } from "react-icons/ci";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../component/Loader";
import Paginations from "../../component/Pagination";
import { variants } from "../../constant/Variants";
import { getTeacherId } from "../../app/globalStore";
import {
  FetchDebtList,
  lists,
  debtCountSelector,
  debtListSelector,
} from "./UserSlice";

function Debtors() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const teacher_id = getTeacherId(); 
  const list = useSelector(debtListSelector);
  const total = useSelector(debtCountSelector);
  // Restore pagination state from sessionStorage on component mount
  const [search, setSearch] = useState(() => {
    return sessionStorage.getItem('debtorsListSearch') || "";
  });
  const [show, setShow] = useState(false);
  const [delId, setDelId] = useState("");
  const [page, setPage] = useState(() => {
    const savedPage = sessionStorage.getItem('debtorsListPage');
    return savedPage ? parseInt(savedPage) : 1;
  });
  const [loading, setLoading] = useState(false);
  let companyOptions = [];
  const companiesStr = localStorage.getItem('companies');
  if (companiesStr) {
    try {
      const companies = JSON.parse(companiesStr);
      if (Array.isArray(companies) && companies.length > 0) {
        companyOptions = [
          { value: 0, label: 'All Companies' },
          ...companies.map(c => ({
            value: c.id,
            label: c.company_name
          }))
        ];
      }
    } catch (e) {
      // Optionally handle JSON parse error
      companyOptions = [];
    }
  }
  // Restore company selection state from sessionStorage on component mount
  const [selectedCompany, setSelectedCompany] = useState(() => {
    const savedCompany = sessionStorage.getItem('debtorsListCompany');
    return savedCompany ? parseInt(savedCompany) : 0;
  });
  const handlePage = (val) => {
    setPage(val);
  };

  const handleShow = () => {
    setShow(!show);
  };

  const getList = useCallback(() => {
    setLoading(true);
    dispatch(FetchDebtList({ company_id: selectedCompany })).then(
      () => {
        setLoading(false);
      }
    );
  }, [dispatch, selectedCompany]);

  useEffect(() => {
    getList();
  }, [getList]);

  // Save page state to sessionStorage whenever it changes
  useEffect(() => {
    sessionStorage.setItem('debtorsListPage', page.toString());
  }, [page]);

  // Save search state to sessionStorage whenever it changes
  useEffect(() => {
    sessionStorage.setItem('debtorsListSearch', search);
  }, [search]);

  // Save company selection state to sessionStorage whenever it changes
  useEffect(() => {
    sessionStorage.setItem('debtorsListCompany', selectedCompany.toString());
  }, [selectedCompany]);


  useEffect(() => {
    return () => {
      dispatch(lists(null));
    };
  }, []);

  return (
    <article className="col-lg-9 articleClass">
      <div className="article-body store-bd-gy">
        <div className="row align-items-center col-rever">
          <div className="col-sm-12 col-md-6 col-lg-6 mb-3">
            <div className="link-active shadow">
              <p>
                <img src="assets/images/users-selected.png" alt="" />
                Outstanding Payments {total}
              </p>
            </div>
          </div>
          <div className="col-sm-12 col-md-6 col-lg-6 mb-3">
            <div className="d-flex align-items-center lg-justify-content-end">
              <form className="has-search">
                <span className="form-search-icon form-control-feedback"></span>
                <input
                  type="text"
                  className="form-control shadow"
                  placeholder="Search user by name"
                  value={search}
                  onChange={(e) => {
                    setPage(1);

                    setSearch(e.target.value);
                  }}
                />
              </form>
            </div>
          </div>
        </div>
        {Array.isArray(companyOptions) && companyOptions.length > 0 && (
        <div className="row mb-4">
        <div className="col-md-6 col-lg-3 mb-3">
        <Select
            options={companyOptions}
            isSearchable
            placeholder="Select a company..."
            value={companyOptions.find(option => option.value === selectedCompany)}
            onChange={option => {
              setSelectedCompany(option.value);
            }}
          />
          </div>
        </div>
        )}
        <div className="row mt-1">
          <div className="col-sm-12">
            <div className="table-responsive text-center">
              <table className="table storetable">
                <thead className="text-center">
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Teacher</th>
                    <th scope="col">User</th>
                    <th scope="col">Student</th>
                    <th scope="col">Email ID</th>
                    <th scope="col">Debt Amount</th>
                    {/* <th scope="col">User wallet Amount</th> */}
                  </tr>
                  <tr className="border-0 bg-none invisible">
                    <td className="border-0 bg-none"></td>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <td colSpan={9}>
                      <Loader />
                    </td>
                  ) : (
                    <>
                      {list?.length > 0 ? (
                        list?.map((item, i) => {
                          return (
                            <tr variants={variants.card} key={i}>
                              <td>{item?.student_details?.id || "NA"}</td>
                              <td>{item?.teacher_details?.full_name || "NA"}</td>
                              <td>
                                <Link to={`/user/${item?.student_details?.parent_details?.id}`}>
                                  {item?.student_details?.parent_details?.first_name ? item?.student_details?.parent_details?.first_name : "NA"}
                                  {item?.student_details?.parent_details?.first_name && item?.student_details?.parent_details?.last_name ? " " : ""}
                                  {item?.student_details?.parent_details?.last_name ? item?.student_details?.parent_details?.last_name : "NA"}
                                </Link>
                              </td>
                              <td>
                                <Link to={`/student/${item?.student_details?.id}`}>
                                  {item?.student_details?.first_name ? item?.student_details?.first_name : "NA"}
                                  {item?.student_details?.first_name && item?.student_details?.last_name ? " " : ""}
                                  {item?.student_details?.last_name ? item?.student_details?.last_name : "NA"}
                                </Link>
                              </td>
                              <td>{item?.student_details?.parent_details?.email ? item?.student_details?.parent_details?.email : "NA"}</td>
                              <td>{item?.actual_amount}</td>
                              
                              {/* <td>{item?.student_details?.parent_details?.wallet ? item?.student_details?.parent_details?.wallet : "NA"}</td> */}
                              <td>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={10}>No data found.</td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {list?.length > 0 && (
            <Paginations
              handlePage={handlePage}
              page={page}
              total={total && total}
            />
          )}
        </div>
      </div>
    </article>
  );
}

export default Debtors;
